<ng-container
    *ngFor="
        let commgroup of commitmentgroup;
        let y = index;
        trackBy: track_identify_commitmentgroup
    "
>
    <div class="perf-tabs-container">
        <span class="perf-tabs-container-title">{{ commgroup.title }}</span>
        <span
            *ngIf="commgroup.subtitle"
            class="perf-tabs-container-sub-title"
            >{{ commgroup.subtitle }}</span
        >
    </div>

    <div class="current-commitments">
        <div
            *ngIf="commgroup.commitments.length"
            class="current-commitments-container"
        >
            <ul
                class="current-commitments-list"
                [ngClass]="!commitmentExpanded ? '' : 'commitment-expanded'"
            >
                <li
                    *ngFor="
                        let item of commgroup.commitments;
                        let i = index;
                        trackBy: track_identify_commitment
                    "
                >
                    <div
                        class="commitment"
                        [ngClass]="{
                            expanded: commgroup.activeCommitment === i
                        }"
                    >
                        <div
                            class="header row nogutter align-items-center"
                            (click)="expandCommitment(y, i)"
                        >
                            <div class="desc">
                                <div>
                                    <div class="cmps-cdk-d-flex desc-header">
                                        <cmps-icon
                                            [svgIcon]="
                                                commgroup.activeCommitment === i
                                                    ? 'chevron-down'
                                                    : 'chevron-right'
                                            "
                                        ></cmps-icon>
                                        <div class="desc-header-sec">
                                            <span
                                                class="desc-main-header d-block"
                                                >{{ item.behaviour }}</span
                                            >
                                            <span class="sub-heading">{{
                                                item.subbehaviour
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="observation-status">
                                        <span class="status">{{
                                            item.statusName
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12 metric-count-container mb-2">
                                <span class="metric-count-sec">
                                    <ng-container
                                        *ngIf="
                                            gettingData === true &&
                                                hasPendingData === false;
                                            else notGettingData
                                        "
                                    >
                                        <cmps-wait-status
                                            class="p-2"
                                        ></cmps-wait-status>
                                    </ng-container>
                                    <ng-template #notGettingData>
                                        <span class="oa-metric-count">
                                            {{
                                                i18n._7375_OA_GOALS | translate
                                            }}:
                                            <span class="metric-count-number">{{
                                                item.activeOAGoalCount
                                            }}</span>
                                        </span>

                                        <span>|</span>
                                        <span class="nonoa-metric-count">
                                            {{
                                                i18n._7376_NON_OA_GOALS
                                                    | translate
                                            }}:
                                            <span class="metric-count-number">{{
                                                item.activeNonOAGoalCount
                                            }}</span>
                                        </span>

                                        <span>|</span>
                                        <span class="nonoa-metric-count">
                                            {{
                                                i18n._7377_OBSERVATIONS
                                                    | translate
                                            }}:
                                            <span class="metric-count-number">{{
                                                item.observationCount
                                            }}</span>
                                        </span>
                                    </ng-template>
                                </span>
                            </div>
                        </div>

                        <div
                            *ngIf="commgroup.activeCommitment == i"
                            class="expand"
                        >
                            <cmps-wait-status
                                *ngIf="hasPendingData === true"
                                class="p-2"
                            ></cmps-wait-status>

                            <ng-container
                                *ngIf="item.details && !hasPendingData"
                            >
                                <div class="commitment-expand-table">
                                    <div class="commitment-expand-table-title">
                                        {{
                                            i18n._7378_COMMITMENT_DETAILS
                                                | translate
                                        }}
                                    </div>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>
                                                    {{
                                                        i18n._7310_SESSION_DATE
                                                            | translate
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        i18n._7309_SESSION_TYPE
                                                            | translate
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        i18n._7308_COACH
                                                            | translate
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        i18n._7316_CONSISTENCY
                                                            | translate
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        i18n._7317_PROFICIENCY
                                                            | translate
                                                    }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody
                                            *ngIf="
                                                item.details
                                                    .commitment as commitment
                                            "
                                        >
                                            <tr>
                                                <td>
                                                    <a
                                                        (click)="
                                                            iframe(
                                                                'Commitment',
                                                                commitment.coachingEventId
                                                            )
                                                        "
                                                        >{{
                                                            commitment.sessionDate
                                                                | date
                                                                    : 'MM/dd/y'
                                                        }}</a
                                                    >
                                                </td>
                                                <td>
                                                    {{
                                                        commitment.sessionTypeName
                                                    }}
                                                </td>
                                                <td>
                                                    {{ commitment.coachName }}
                                                </td>
                                                <td>
                                                    {{ commitment.consistency }}
                                                </td>
                                                <td>
                                                    {{ commitment.proficiency }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="commitment-expand-table">
                                    <div class="commitment-expand-table-title">
                                        {{
                                            i18n._7379_OBSERVATION_DETAILS
                                                | translate
                                        }}
                                    </div>
                                    <div>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {{
                                                            i18n._7310_SESSION_DATE
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7309_SESSION_TYPE
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7347_OBSERVER
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7380___OF_INTERACTIONS
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7315___OF_EVALUATIONS
                                                                | translate
                                                        }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                *ngIf="
                                                    item.details
                                                        .observations as observations
                                                "
                                            >
                                                <tr
                                                    *ngFor="
                                                        let o of observations
                                                    "
                                                >
                                                    <td>
                                                        <a
                                                            (click)="
                                                                iframe(
                                                                    'Observation',
                                                                    o.coachingEventId
                                                                )
                                                            "
                                                            >{{
                                                                o.sessionDate
                                                                    | date
                                                                        : 'MM/dd/y'
                                                            }}</a
                                                        >
                                                    </td>
                                                    <td>
                                                        {{ o.sessionTypeName }}
                                                    </td>
                                                    <td>{{ o.coachName }}</td>
                                                    <td>
                                                        {{ o.interactionCount }}
                                                    </td>
                                                    <td>
                                                        {{ o.evaluationCount }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="commitment-expand-table">
                                    <div class="commitment-expand-table-title">
                                        {{
                                            i18n._7381_GOAL_DETAILS | translate
                                        }}
                                    </div>
                                    <div>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {{
                                                            i18n._713_METRIC
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._721_GOAL
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7329_CREATED_ON
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._127_STATUS
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7383_ACTUAL__INITIAL_
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7384___TO_GOAL__INITIAL_
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7385_ACTUAL__CURRENT_
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7386___TO_GOAL__CURRENT_
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            i18n._7328_EST__COMPLETION_DATE
                                                                | translate
                                                        }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                *ngIf="
                                                    item.details.goals as goals
                                                "
                                            >
                                                <tr *ngFor="let g of goals">
                                                    <td>{{ g.metric }}</td>
                                                    <td>{{ g.goalValue }}</td>
                                                    <td>
                                                        {{
                                                            g.createdOn
                                                                | date
                                                                    : 'MM/dd/y'
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            g.currentPerformanceGoalStatus
                                                        }}
                                                    </td>
                                                    <ng-container
                                                        *ngIf="
                                                            periodType ==
                                                                PeriodType.MONTH;
                                                            else rolling30
                                                        "
                                                    >
                                                        <td
                                                            [style.color]="
                                                                g.monthThresholdInit
                                                            "
                                                        >
                                                            {{
                                                                g.actualMTDInitValue
                                                                    | number
                                                                        : '1.2-2'
                                                            }}
                                                            <cmps-icon
                                                                [class]="
                                                                    (g.actualMonthTrendInit
                                                                        | trendArrow)[0]
                                                                "
                                                                [svgIcon]="
                                                                    (g.actualMonthTrendInit
                                                                        | trendArrow)[1]
                                                                "
                                                            ></cmps-icon>
                                                        </td>
                                                        <td>
                                                            {{
                                                                g.percentGoalInit
                                                                    | number
                                                                        : '1.2-2'
                                                            }}
                                                        </td>
                                                        <td
                                                            [style.color]="
                                                                g.monthThreshold
                                                            "
                                                        >
                                                            {{
                                                                g.actualMTDValue
                                                                    | number
                                                                        : '1.2-2'
                                                            }}
                                                            <cmps-icon
                                                                [class]="
                                                                    (g.actualMonthTrend
                                                                        | trendArrow)[0]
                                                                "
                                                                [svgIcon]="
                                                                    (g.actualMonthTrend
                                                                        | trendArrow)[1]
                                                                "
                                                            ></cmps-icon>
                                                        </td>
                                                        <td>
                                                            {{
                                                                g.percentGoal
                                                                    | number
                                                                        : '1.2-2'
                                                            }}
                                                        </td>
                                                    </ng-container>
                                                    <ng-template #rolling30>
                                                        <td
                                                            [style.color]="
                                                                g.monthThresholdInit
                                                            "
                                                        >
                                                            {{
                                                                g.actualMTDInitValue
                                                                    | number
                                                                        : '1.2-2'
                                                            }}
                                                            <cmps-icon
                                                                [class]="
                                                                    (g.actualMonthTrendInit
                                                                        | trendArrow)[0]
                                                                "
                                                                [svgIcon]="
                                                                    (g.actualMonthTrendInit
                                                                        | trendArrow)[1]
                                                                "
                                                            ></cmps-icon>
                                                        </td>
                                                        <td>
                                                            {{
                                                                g.percentGoalInit
                                                                    | number
                                                                        : '1.2-2'
                                                            }}
                                                        </td>
                                                        <td
                                                            [style.color]="
                                                                g.monthThreshold
                                                            "
                                                        >
                                                            {{
                                                                g.actualMTDValue
                                                                    | number
                                                                        : '1.2-2'
                                                            }}
                                                            <cmps-icon
                                                                [class]="
                                                                    (g.actualMonthTrend
                                                                        | trendArrow)[0]
                                                                "
                                                                [svgIcon]="
                                                                    (g.actualMonthTrend
                                                                        | trendArrow)[1]
                                                                "
                                                            ></cmps-icon>
                                                        </td>
                                                        <td>
                                                            {{
                                                                g.percentGoal
                                                                    | number
                                                                        : '1.2-2'
                                                            }}
                                                        </td>
                                                    </ng-template>
                                                    <ng-container
                                                        *ngIf="
                                                            g.currentPerformanceGoalStatusId !=
                                                                _GoalStatus.CLOSED;
                                                            else closedPGoal
                                                        "
                                                    >
                                                        <td>
                                                            {{
                                                                g.expectedCompletionDate
                                                                    | date
                                                                        : 'MM/dd/y'
                                                            }}
                                                        </td>
                                                    </ng-container>
                                                    <ng-template #closedPGoal>
                                                        <td>
                                                            {{
                                                                g.updatedOn
                                                                    | date
                                                                        : 'MM/dd/y'
                                                            }}
                                                        </td>
                                                    </ng-template>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container
                                *ngIf="!item.details && !hasPendingData"
                            >
                                <div class="text-center p-3">
                                    {{
                                        i18n._7388_UNABLE_TO_RETRIEVE_DATA_FOR_COMMITMENT
                                            | translate
                                    }}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="commitmentgroup && !commitmentgroup.length">
    <div class="perf-tabs-container">
        <span class="perf-tabs-container-title">{{
            i18n._7389_CURRENT_COMMITMENTS | translate
        }}</span>
    </div>

    <div class="no-commitments">
        <div class="no-commitments-content">
            <div class="no-commitments-text">
                {{ i18n._7390_NO_COMMITMENTS_AVAILABLE | translate }}
            </div>
        </div>
    </div>
</ng-container>
